import React from 'react';
import PropTypes from 'prop-types';
import { IsWidgetAccessible } from '../../utils/widgetManager';
import { FormattedMessage } from 'react-intl';
import { Navigate } from 'react-router-dom';

const AdminControls = ({ userProfileWidgets }) => (
  <div>
    {IsWidgetAccessible(userProfileWidgets, 'ORGANISATION_TAB') ? (
      <Navigate to="/admin-controls/organisation-list" />
    ) : IsWidgetAccessible(userProfileWidgets, 'USERS_TAB') ? (
      <Navigate to="/admin-controls/user-list" />
    ) : IsWidgetAccessible(userProfileWidgets, 'PROFILES_TAB') ? (
      <Navigate to="/admin-controls/profile-list" />
    )  : IsWidgetAccessible(userProfileWidgets, 'NOTIFICATIONS_TAB') ? (
      <Navigate to="/admin-controls/notifications" />
    ) : IsWidgetAccessible(userProfileWidgets, 'FAQ_TAB') ? (
      <Navigate to="/admin-controls/faqs" />
    ) : IsWidgetAccessible(userProfileWidgets, 'RELEASENOTELIST') ? (
      <Navigate to="/admin-controls/release-notes" />
    ) : (
      ''
    )}
    <span>
      <FormattedMessage
        id="AdminControls.NoAccess"
        defaultMessage="You do not have access to Admin Controls. Please contact your administrator."
      />
    </span>
  </div>
);

AdminControls.propTypes = {
  userProfileWidgets: PropTypes.object.isRequired
};

export default AdminControls;
